export default "/assets/images/mila-feed-13.73c0b3a3ecf63d23.mp4";